/**
 * 前台登录文本 注册 忘记密码文本
 * @type {{password: string, forgetPassword: string, passwordMessage: string, userNameMessage: string, userName: string, login: string, register: string}}
 */
const loginLangCN = {
    userName: "用户名",
    userNameMessage: "请填写用户名",
    password: "密码",
    passwordMessage: "请填写密码",
    register: "注册",
    forgetPassword: "忘记密码？",
    login: "登录",
    phoneNumber: "手机号",
    phoneMessage:"请填写手机号",
    messageCode: "短信验证码",
    messageCodeHint: "请填写手机短信验证码",
    sendCode:"发送验证码",
    confirmPassword:"确认密码",
    confirmPasswordMessage:"请输入正确密码",
    returnLogin:"返回登录页面",
    submitPasswordChange:"提 交 更 改 密 码",
    title:"语言切换",
}


const loginLangEN = {
    userName: "Username",
    userNameMessage: "Enter username",
    password: "Password",
    passwordMessage: "Enter password",
    register: "Register",
    forgetPassword: "Forgot password？",
    login: "Log in",
    phoneNumber: "Phone",
    phoneMessage:"Please enter your phone number",
    messageCode: "Verification code",
    messageCodeHint: "Please enter the verification code",
    sendCode:"Send verification code",
    confirmPassword:"Re-enter password",
    confirmPasswordMessage:"Please re-enter the password",
    returnLogin:"Go back to log in",
    submitPasswordChange:"Please re-enter the password",
    title:"Language switch",
}

const langPackage = {
    cn: loginLangCN,
    en: loginLangEN
}


export {langPackage}
